import { ServiceCategory, ServiceType } from '@/types';

export const SERVICE_CATEGORIES: Record<ServiceCategory, { en: string; fr: string }> = {
  errands: { en: 'Errands & Shopping', fr: 'Courses et Achats' },
  transportation: { en: 'Transportation', fr: 'Transport' },
  social: { en: 'Social Activities', fr: 'Activités Sociales' },
  indoor: { en: 'Indoor Help', fr: 'Travaux Intérieurs' },
  outdoor: { en: 'Outdoor Work', fr: 'Travaux Extérieurs' },
  personal_support: { en: 'Personal Support / Safety', fr: 'Soutien personnel / sécurité' },
  exercise: { en: 'Exercise & Wellness', fr: 'Exercice et Bien-être' },
  pets: { en: 'Pet Services', fr: 'Services pour Animaux' },
};

export const SERVICE_TYPES: ServiceType[] = [
  // Errands & Shopping
  {
    id: 'errands_store_item',
    category: 'errands',
    name: { en: 'Get an item at the store', fr: 'Récupérer un article au magasin' },
    icon: '🛒',
  },
  {
    id: 'errands_grocery',
    category: 'errands',
    name: { en: 'Grocery shopping', fr: 'Faire les courses' },
    icon: '🛍️',
  },
  {
    id: 'errands_medication',
    category: 'errands',
    name: { en: 'Medication pickup', fr: 'Récupération de médicaments' },
    icon: '💊',
  },

  // Transportation
  {
    id: 'transport_appointment',
    category: 'transportation',
    name: { en: 'Ride to an appointment', fr: 'Trajet vers un rendez-vous' },
    icon: '🚗',
  },
  {
    id: 'transport_walking',
    category: 'transportation',
    name: { en: 'Help walking to a place', fr: 'Accompagnement à pied' },
    icon: '🚶',
  },

  // Social Activities
  {
    id: 'social_meal',
    category: 'social',
    name: { en: 'Join for a meal in the neighborhood', fr: 'Partager un repas dans le quartier' },
    icon: '🍽️',
  },
  {
    id: 'social_coffee',
    category: 'social',
    name: { en: 'Coffee companion', fr: 'Compagnon de café' },
    icon: '☕',
  },
  {
    id: 'social_event',
    category: 'social',
    name: { en: 'Movie or event buddy', fr: 'Partenaire de sortie' },
    icon: '🎬',
  },

  // Indoor Help
  {
    id: 'indoor_hanging',
    category: 'indoor',
    name: { en: 'Install wall hangings', fr: 'Installer des cadres' },
    icon: '🖼️',
  },
  {
    id: 'indoor_repairs',
    category: 'indoor',
    name: { en: 'Minor repairs', fr: 'Petites réparations' },
    icon: '🔧',
  },
  {
    id: 'indoor_furniture',
    category: 'indoor',
    name: { en: 'Furniture assembly', fr: 'Montage de meubles' },
    icon: '🪑',
  },

  // Outdoor Work
  {
    id: 'outdoor_gardening',
    category: 'outdoor',
    name: { en: 'Gardening', fr: 'Jardinage' },
    icon: '🌱',
  },
  {
    id: 'outdoor_snow',
    category: 'outdoor',
    name: { en: 'Snow shoveling', fr: 'Pelletage' },
    icon: '❄️',
  },

  // Personal Support / Safety
  {
    id: 'support_listen',
    category: 'personal_support',
    name: { en: 'Listen (with discretion)', fr: 'Écouter (avec discrétion)' },
    icon: '👂',
  },
  {
    id: 'support_checkin',
    category: 'personal_support',
    name: { en: 'Routine safety check-in call', fr: 'Appeler pour sécurité routinière' },
    icon: '📞',
  },
  {
    id: 'support_visit',
    category: 'personal_support',
    name: {
      en: 'Short visit for well-being and check-in',
      fr: 'Visite signe de vie et échange court',
    },
    icon: '🏠',
  },

  // Exercise & Wellness
  {
    id: 'exercise_walking',
    category: 'exercise',
    name: { en: 'Walking companion', fr: 'Compagnon de marche' },
    icon: '🚶‍♂️',
  },
  {
    id: 'exercise_jogging',
    category: 'exercise',
    name: { en: 'Jogging buddy', fr: 'Partenaire de jogging' },
    icon: '🏃',
  },
  {
    id: 'exercise_light',
    category: 'exercise',
    name: { en: 'Light exercise assistance', fr: 'Assistance pour exercices légers' },
    icon: '🧘',
  },

  // Pet Services
  {
    id: 'pets_walk',
    category: 'pets',
    name: { en: 'Walk pet with owner', fr: "Promenade d'un animal avec le propriétaire" },
    icon: '🐕',
  },
  {
    id: 'pets_jogging',
    category: 'pets',
    name: { en: 'Pet jogging', fr: 'Jogging avec un animal' },
    icon: '🐕‍🦺',
  },
  {
    id: 'pets_sitting',
    category: 'pets',
    name: { en: 'Pet sitting', fr: "Garde d'animaux" },
    icon: '🐾',
  },
];

export const getServiceTypeById = (id: string): ServiceType | undefined => {
  return SERVICE_TYPES.find((st) => st.id === id);
};

export const getServiceTypesByCategory = (category: ServiceCategory): ServiceType[] => {
  return SERVICE_TYPES.filter((st) => st.category === category);
};

export const getServiceTypesByIds = (ids: string[]): ServiceType[] => {
  return ids.map((id) => getServiceTypeById(id)).filter((st): st is ServiceType => st !== undefined);
};
